export default __webpack_public_path__ + "154211b038f3fa7f2fd269dde178549c.ttf";